import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import logo from "../../assets/Logo.png";
import homelogo from "../../assets/home_image.png";

const SearchIcon = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

const CheckIcon = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const UploadIcon = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
    />
  </svg>
);

const LocationIcon = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);

const MailIcon = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

const PhoneIcon = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
    />
  </svg>
);

const HomeHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="home-header">
      <div className="header-content">
        <div className="header-logo space-x-2">
          <img src={logo} width={55} height={55} alt="insecta logo" />
          <span>Insecta</span>
        </div>
        <nav className="header-nav">
          <a href="#inicio">Página Inicial</a>
          <a href="#sobre">Sobre</a>
          <a href="#contato">Contato</a>
        </nav>
        <div
          className="header-actions"
          style={{ display: "flex", gap: "0.5rem" }}
        >
          <button
            className="btn btn-register"
            onClick={() => navigate("/register")}
          >
            Registre-se
          </button>
          <button className="btn btn-login" onClick={() => navigate("/login")}>
            Entrar
          </button>
        </div>
      </div>
    </header>
  );
};

const HomePage = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section id="inicio" className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Banco de Imagens - Insecta</h1>
            <p className="hero-description">
              Explore um acervo rico em imagens de insetos, com informações
              detalhadas sobre cada espécie, suas características morfológicas e
              habitats, tudo em uma plataforma intuitiva que torna a pesquisa
              fácil e rápida.
            </p>
          </div>
          <div className="hero-illustration-area">
            {/* Imagem centralizada e redonda */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <img
                src={homelogo}
                alt="Insecta Home"
                style={{
                  width: "350px",
                  height: "350px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="sobre" className="section-container">
        <h2 className="section-title">
          Sistema de Busca Avançada de Asas de Insetos
        </h2>
        <p className="section-subtitle">
          A plataforma foi desenvolvida para facilitar a busca e visualização de
          informações detalhadas sobre diversas espécies de insetos. Destinada a
          pesquisadores, estudantes e entusiastas, ela oferece funcionalidades
          avançadas, como busca por nome científico, filtros dinâmicos e uma
          galeria de imagens. Com uma interface intuitiva e responsiva, a
          plataforma garante acesso fácil e eficiente a um banco de dados
          robusto, disponível em qualquer dispositivo.
        </p>
        <div className="features-grid">
          <div className="feature-card">
            <div className="icon-bg">
              <SearchIcon />
            </div>
            <h3>Busca por Espécie</h3>
            <p>
              Busque por nome científico e veja resultados com imagens e
              descrições detalhadas.
            </p>
          </div>
          <div className="feature-card">
            <div className="icon-bg">
              <CheckIcon />
            </div>
            <h3>Filtros Avançados</h3>
            <p>
              Refine sua pesquisa por características morfológicas, família ou
              localização geográfica.
            </p>
          </div>
          <div className="feature-card">
            <div className="icon-bg">
              <UploadIcon />
            </div>
            <h3>Contribuição Colaborativa</h3>
            <p>
              Colabore enviando imagens e informações para o banco de dados, com
              aprovação da administração.
            </p>
          </div>
        </div>
      </section>

      {/* Collaboration Flow Section */}
      <section className="flow-section section-container">
        <div className="flow-content">
          <div className="flow-text-content">
            <h2 className="section-title">
              Fluxo de Colaboração e Acesso de Imagens
            </h2>
            <p>
              Nossa plataforma foi criada para facilitar a colaboração e o
              compartilhamento de imagens detalhadas de diversas espécies de
              insetos. Através de um processo simples e organizado,
              pesquisadores e entusiastas podem contribuir com novas fotos e
              informações, ou acessar e baixar imagens já aprovadas. Cada
              colaboração passa por uma análise criteriosa, garantindo a
              qualidade e precisão dos dados disponíveis. Junte-se a nós e ajude
              a expandir o conhecimento sobre o mundo dos insetos.
            </p>
          </div>
          <div className="flow-steps-grid">
            <div className="flow-step-card">
              <div className="icon-bg">
                <span>1.</span>
              </div>
              <h3>Cadastrar no Sistema</h3>
              <p>
                Crie sua conta para acessar a plataforma e explorar o conteúdo.
              </p>
            </div>
            <div className="flow-step-card">
              <div className="icon-bg">
                <span>2.</span>
              </div>
              <h3>Confirmação de Cadastro</h3>
              <p>
                Abra a caixa do email cadastrado e clique no link de ativação.
              </p>
            </div>
            <div className="flow-step-card">
              <div className="icon-bg">
                <span>3.</span>
              </div>
              <h3>Preenchimento do Formulário e Upload de Fotos</h3>
              <p>
                Acesse a sua conta e adicione fotos e informações detalhadas
                sobre as espécies ou baixe imagens já disponíveis no sistema.
              </p>
            </div>
            <div className="flow-step-card">
              <div className="icon-bg">
                <span>4.</span>
              </div>
              <h3>Avaliação Final pelo Admin</h3>
              <p>
                Após a avaliação, sua contribuição estará disponível para todos
                os usuários, e você poderá baixar mais imagens.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contato" className="section-container">
        <div className="contact-card">
          <div className="contact-info">
            <h2>Entre em contato</h2>
            <p>
              Dúvidas ou precisa de ajuda? Entre em contato com nossa equipe de
              suporte e descubra como colaborar ou baixar imagens facilmente!
            </p>
            <div className="contact-details">
              <div className="contact-detail-item">
                <div className="icon-bg">
                  <LocationIcon />
                </div>
                <span>Cruz das Almas, BA</span>
              </div>
              <div className="contact-detail-item">
                <div className="icon-bg">
                  <MailIcon />
                </div>
                <a href="mailto:insecta@ufrb.edu.br">insecta@ufrb.edu.br</a>
              </div>
              <div className="contact-detail-item">
                <div className="icon-bg">
                  <PhoneIcon />
                </div>
                <span>00-1234 00000</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

// ========= MAIN APP COMPONENT =========
const Home = () => {
  return (
    <>
      <HomeHeader />
      <HomePage />
    </>
  );
};

export default Home;
